var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-modal-confirmation',{attrs:{"title":_vm.modalTitle,"text":_vm.modalConfirmationText,"modal":_vm.modal,"submitButtonText":_vm.modalSubmitButtonText,"isSubmitting":_vm.isSubmitting},on:{"closeModal":_vm.handleCloseModal,"submitModal":_vm.handleSubmitModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }